/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * HintsPanel.tsx — Hint\1 \2anel (services/operator-web-app).
 */

import { useCopilot } from '@/store';
import { HintCard } from './HintCard';
import { useTranslation } from '@/i18n';

/**
 * E6-S2: Hints panel — shows priority (first non-dismissed) hint card, then "ещё N" if any.
 * Plan: 08 (one priority hint at a time).
 */
export function HintsPanel() {
  const t = useTranslation();
  const copilot = useCopilot();
  const dismissed = new Set(copilot.dismissedHintIds);
  const visibleHints = copilot.hints.filter((h) => !dismissed.has(h.hintId));
  const priorityHint = visibleHints[0];
  const restCount = visibleHints.length - 1;

  return (
    <div className="flex flex-col gap-2 min-h-0" aria-label={t('hints.label')}>
      {priorityHint ? (
        <>
          <HintCard hint={priorityHint} />
          {restCount > 0 && (
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
              {t('hints.more', { count: restCount })}
            </p>
          )}
        </>
      ) : (
        <p className="text-sm py-2" style={{ color: 'var(--text-muted)' }}>
          {t('hints.empty')}
        </p>
      )}
    </div>
  );
}
